import { getBoardIntegrations } from "frontend/api";

export const getMondayBoardItemMapping = async (
  documentId: string,
  integrationId: string
): Promise<{
  mapping: Record<string, string>;
  shouldApplyForAll: boolean;
} | null> => {
  const allConfigurations = await getBoardIntegrations(documentId);
  const configuration = allConfigurations.find((c: any) => c.id === integrationId);
  return configuration.configuration?.columnMappings;
};

export const combineMappingWithData = (
  columnMappings: Record<string, string> | null,
  item: {
    name: string;
    columnValues: {
      id: string;
      type: string;
      value: string;
    }[];
  }
) => {
  const useTimelineColumn = columnMappings?.["date-tab"] === "timeline";
  const startId = useTimelineColumn ? undefined : columnMappings?.start_date;
  const endId = useTimelineColumn ? undefined : columnMappings?.end_date;
  const dependencyId = columnMappings?.dependency;
  const timelineId = useTimelineColumn ? columnMappings?.timeline : undefined;

  const dateColumns = item?.columnValues?.filter((column: any) => column.type === "date");
  let startDate = dateColumns?.find((column: any) => column.id === startId)?.value || "";
  let endDate = dateColumns?.find((column: any) => column.id === endId)?.value || "";
  const title = item?.name ?? "";

  const dependentTaskIds = item?.columnValues?.find((column: any) => column.id === dependencyId)?.value || "";
  let dependencies: string[] = [];
  if (dependentTaskIds) {
    if (typeof dependentTaskIds === "object") {
      dependencies = ((dependentTaskIds as any)?.linkedPulseIds ?? []).map((d: any) => d.linkedPulseId.toString());
    } else {
      dependencies =
        (JSON.parse(dependentTaskIds)?.linkedPulseIds ?? []).map((d: any) => d.linkedPulseId.toString()) ?? [];
    }
  }

  // https://preview.dev.workcanvas.com/pr-3111/d/5abJ-uDFtJizq2k6v56Lge2htJHJvoJX#

  const timeline =
    item?.columnValues?.find((column: any) => column.id === timelineId)?.value ||
    ("" as
      | string
      | {
          to: string;
          from: string;
        });

  if (timeline) {
    if (typeof timeline === "string") {
      const [timelineStart, timelineEnd] = timeline?.split(" - ") || [];
      startDate = timelineStart;
      endDate = timelineEnd;
    } else {
      startDate = timeline.from;
      endDate = timeline.to;
    }
  }

  return {
    startDate: new Date(new Date(startDate).toDateString()).getTime(),
    endDate: new Date(new Date(endDate).toDateString()).getTime(),
    dependencies,
    title,
    dependencyId,
    timelineId,
    startId,
    endId,
  };
};
